export const StatusType = {
  AVAILABLE: 'available',
  UNAVAILABLE_ALERT_ONLY: 'unavailable_alert_only',
  UNAVAILABLE_CHECKING: 'unavailable_checking',
  UNAVAILABLE_FAILED: 'unavailable_failed'
} as const;
export type StatusTypeValue = (typeof StatusType)[keyof typeof StatusType];

export interface KpiStatusRow {
  company: string;
  run_date_pacific: string;
  attempts: number;
  message: string;
  last_modified: string;
  available: boolean;
  failed: boolean;
  alert_only: boolean;
}

export interface KpiStatusDisplayRow extends KpiStatusRow {
  status_type: StatusTypeValue;
}

export interface KpiStatusClientResponse {
  statuses: KpiStatusRow[];
}
